import styled from 'styled-components'

import { NATIVE_BASE_COLORS, COLOR, FONT_SIZE } from '../../../../themes'

export const StylesRepeatOptions = styled.div`
  display: flex;
  align-items: center;
  padding: ${(props) => (props.isMonthly ? '12px' : '8px 12px')};
  cursor: pointer;

  &:hover {
    background-color: ${COLOR.HOVER_REPEAT_BOOKING};
  }

  .option-text {
    font-family: NunitoSansRegular;
    font-size: ${FONT_SIZE.XXS};
    color: ${NATIVE_BASE_COLORS.TEXT[800]};
    margin-left: 32px;
    cursor: pointer;
  }

  .option-active-text {
    font-family: NunitoSansSemibold;
    font-size: ${FONT_SIZE.XXS};
    color: ${NATIVE_BASE_COLORS.TEXT[800]};
    margin-left: 10px;
    cursor: pointer;
  }

  .check-icon {
    color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
  }

`
